import { useAppSelector } from 'hooks'

import { getUserHomePage } from '../lib'
import { selectUser } from '../selectors'

export const useUser = () => useAppSelector(selectUser)

export const useUserHomepage = () => getUserHomePage(useUser())
